import { render, staticRenderFns } from "./VideoHover.vue?vue&type=template&id=3badb9d2&lang=pug&"
import script from "./VideoHover.vue?vue&type=script&lang=js&"
export * from "./VideoHover.vue?vue&type=script&lang=js&"
import style0 from "./VideoHover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports